// Single source of email normalisation for the whole application. Email
// identity is case- and whitespace-insensitive, so every comparison, lookup
// and write routes through here to stay consistent.

/**
 * Coerce an arbitrary value to a canonical email string: trimmed and
 * lower-cased. Nullish or non-stringable values collapse to ''.
 */
export function normalizeEmail(value: unknown): string {
  if (value === null || value === undefined) return '';
  return String(value).trim().toLowerCase();
}
